<template>
  <AppDialog
    key="insights-integration-failure"
    append-to-body
    :show="show"
    size="smedium"
    title="Integration failed"
    class="insights-integration-dialog"
    @close="closeDialog"
  >
    <img
      class="d-block mx-auto mb-40"
      width="80%"
      :src="image.src"
      :alt="image.alt"
    />

    <div>
      <p>Sorry, it looks like you don't have permission to access the team's calendars.</p>
      <p>If you still want to integrate it, please contact your organization owner or manager.</p>
    </div>

    <AppButton
      class="d-block mt-30 mx-auto"
      type="primary"
      @click="closeDialog"
    >
      Got it
    </AppButton>
  </AppDialog>
</template>

<script>
import { INSIGHTS_ASSETS as INSIGHTS } from '~/app_constants';
import AppButton from '~/components/AppButton.vue';
import AppDialog from '~/components/AppDialog.vue';

export default {
  name: 'InsightsIntegrationFailureDialog',
  components: {
    AppDialog,
    AppButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    image() {
      return INSIGHTS.integration_unauthorized;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
